function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as style from './avatar-icon.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AvatarIcon = props => {
  var className = props.className ? "domain-icon ".concat(props.className) : 'domain-icon';
  return ___EmotionJSX("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    css: style.avatarIcon,
    className: className
  }), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M2.593 24v-2.3c0-6.093 6.426-6.093 7.615-7.684l.14-.728c-1.675-.846-2.854-2.885-2.854-5.267C7.494 4.88 9.54 3 12.064 3c2.52 0 4.567 1.877 4.567 5.02 0 2.362-1.15 4.39-2.806 5.245l.16.828c1.307 1.52 7.423 1.615 7.423 7.607V24H2.593z"
  }));
};
export default AvatarIcon;